// document.addEventListener('DOMContentLoaded',function(){
//   var readMoreBtn = document.querySelector(".readmore-btnwrap .btn");
//   console.log("readMore Button",readMoreBtn);
//   if(readMoreBtn){
//     readMoreBtn.addEventListener('click',function(){
//       document.querySelector(".promobox__text-3.readmore-content")?.classList.add('active');
//       readMoreBtn.style.display = 'none';
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  // Check if LocalStorage is supported
  if (!isLocalStorageSupported()) {
    console.warn("LocalStorage not supported or disabled in Safari.");
    return;
  }

  // Get the selector element
  var selector = document.querySelector(".select-blogtags");

  // Check if the selector exists
  if (!selector) {
    console.error("Selector '.select-blogtags' not found.");
    return;
  }

  // Check if a data-handle value exists in localStorage and set it if found
  var savedHandle = localStorage.getItem("blogTagHandle");
  if (savedHandle) {
    // Set the selected option based on the saved handle
    var option = selector.querySelector(`[data-handle="${savedHandle}"]`);
    if (option) {
      option.selected = true;
    }
  }

  // When the select box value changes
  selector.addEventListener("change", function () {
    var url = this.value; // Get the selected URL
    console.log("Selected URL: ", url);

    // Save the data-handle of the selected option to localStorage
    var selectedOption = this.options[this.selectedIndex];
    var handle = selectedOption.getAttribute("data-handle");
    if (handle) {
      localStorage.setItem("blogTagHandle", handle); // Save to localStorage
    }

    // Redirect to the selected URL
    window.location.href = url;
  });

  // Function to check LocalStorage support
  function isLocalStorageSupported() {
    try {
      localStorage.setItem("test", "test");
      localStorage.removeItem("test");
      return true;
    } catch (e) {
      return false;
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
//   // Get the selector element
//   var selector = document.querySelector(".select-blogtags");

//   // Check if a data-handle value exists in localStorage and set it if found
//   var savedHandle = localStorage.getItem("blogTagHandle");
//   if (savedHandle) {
//     // Set the selected option based on the saved handle
//     var option = selector.querySelector(`[data-handle="${savedHandle}"]`);
//     if (option) {
//       option.selected = true;
//     }
//   }

//   // When the select box value changes
//   selector.addEventListener('change', function () {
//     var url = this.value; // Get the selected URL
//     console.log("url : ---", url);
    
//     // Save the data-handle of the selected option to localStorage
//     var selectedOption = this.options[this.selectedIndex];
//     var handle = selectedOption.getAttribute("data-handle");
//     localStorage.setItem("blogTagHandle", handle); // Save to localStorage
    
//     // Redirect to the selected URL
//     window.location.href = url;
//   });

const cusTagButtons = document.querySelectorAll('.filter_btn.cus_tag');
  // Get all other filter buttons (non 'cus_tag' buttons)
  const otherButtons = document.querySelectorAll('.filter_btn:not(.cus_tag)');
  
  // Add a click event listener to each 'cus_tag' filter button
  cusTagButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      // Hide the .blog-tags element
      const blogTags = document.querySelector('.blog-tags');
      if (blogTags) {
        blogTags.style.display = 'none';
      }
    });
  });

  // Add a click event listener to each non 'cus_tag' filter button
  otherButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      // Show the .blog-tags element and set display to flex
      const blogTags = document.querySelector('.blog-tags');
      if (blogTags) {
        blogTags.style.display = 'flex';  // Or 'block' if you prefer block display
      }
    });
  });
  
});

// Collection Page Filter Js Start
jQuery(document).on('click', '.filter_btn', function(){
  var currentFilter = jQuery(this).attr("data-filter-handle");
  jQuery('.filter_btn').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.product-block').hide();
  jQuery(currentFilter).show();
  
});

// ReORder Filter Options
(function($) {
    $.fn.reOrder = function(array) {
    return this.each(function() {
     if (array) {    
       for(var i=0; i < array.length; i++) 
         array[i] = jQuery('label.'+ array[i] +'');
       jQuery(this).empty();  
       for(var i=0; i < array.length; i++)
         jQuery(this).append(array[i]);      
     }
    });    
    }
  })(jQuery);

function checkSealerFilter() {
  if(jQuery('.collection-current-filters__item').length > 0) {
    if(jQuery('.collection-current-filters__item').hasClass('value_heat-sealer')) {
      jQuery('#CollectionSidebar').addClass('activeSealer');
    } else {
      jQuery('#CollectionSidebar').removeClass('activeSealer');
    }
  }
}


var _learnq = _learnq || [];
document.addEventListener('rebuy:cart.add', function(event){ 
 
  if(event.detail.item.id != undefined) {
    _learnq.push(['track', 'Added to Cart', event.detail.item])
  }
  
//   console.log(event.detail.cart.cart.total_price/100);
//   rdt('track', 'AddToCart', {
//     itemCount: event.detail.cart.cart.item_count,
//     value: (event.detail.cart.cart.total_price/100),
//     currency: 'USD'
//   });
}); 



document.addEventListener('rebuy:smartcart.show', function(event){ 
  rdt('track', 'AddToCart', {
    itemCount: event.detail.smartcart.cart.item_count,
    value: (event.detail.smartcart.cart.total_price/100),
    currency: 'USD'
  });
}); 


// Collection Page Filter Js Start
// Product Video Section Start
if(jQuery('.product-video-section .row').length > 0) {
  setTimeout(function(){  
  },200)
}

// Product Video Section End
function instantBuy(){
    var $ = jQuery;
    var formParams = jQuery('.product-page-info [data-js-product-form], .one-product-info [data-js-product-form]').serialize();

    console.log(formParams);

    $.ajax({
      url: "/cart/add",
      type: "post",
      data: formParams,
      success: function(){
        window.location.href = "/checkout";
      },
      error: function(e){
        if(e.status == 422){
          
        }
      }
    })
  }

jQuery(document).ready(function($) {
  checkSealerFilter();
  if(jQuery('body').hasClass('product-template')) {
    try {
        var currentVariantID = jQuery("[name='id']").val();
        if(currentProductVariants.length > 0) {
          var currentVariantMetafield = currentProductVariants.filter(element => {
            return element.variant_id == currentVariantID
          });
        
          if(jQuery('.bundle_description').length > 0) {
            jQuery('.bundle_description').text(currentVariantMetafield[0].metafields[0]['bundle_description'])
          }
        }
      } catch(error) {
        console.log(error);
      }
    }


    // Re-Order Filter Options
    if(jQuery('[data-sorting-filter-option]').length > 0) {
      jQuery('[data-sorting-filter-option]').each(function(index, element){
          var sortingValue = jQuery(element).attr('data-order');
          var sortingArray = sortingValue.split(',');
           jQuery(this).children('div.col-12').reOrder(sortingArray);
      });
    }
  

//   if(jQuery('.product-video-section .row').length > 0) {
//     jQuery('.product-video-section .row').slick({ 
//       dots: false,
//       infinite: false,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true,
//         arrows: false
//       }
//     }
//   ]
//     });
//   }
  
  
  if(jQuery('.parallax-container').length > 0){
    jQuery(document).ready(function(){
      jQuery('.bgPara1').parallax("50%", 0.1);
      jQuery('.bgPara2').parallax("40%", 0.5);
      jQuery('.bgPara3').parallax("30%", 0.9);
      jQuery('.bgPara4').parallax("60%", 0.3);
    });
  }
  
  
  jQuery(document).on('click', '.swatch_mobile', function(){
    jQuery(this).siblings().removeClass('selected');
    jQuery(this).addClass('selected');
    var relateVariant = jQuery(this).attr('data-trigger');
    jQuery(this).parents(".product-page-info__options").find('[data-value="'+relateVariant+'"]').trigger('click');
  })
});


function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

window.addEventListener('load', (event) => {
  // if(jQuery('body').hasClass('template-product')) {
  //    jQuery('.write-review').show(); 
  // }
  jQuery('.product-options').show();
});


// jQuery(document).ready(function() {
//   var popupCookie = getCookie('popup-hide');
//   if(popupCookie == null && jQuery("#onLoadCookiePopup").length > 0) {
//     jQuery.fancybox.open({
//       src  : '#onLoadCookiePopup',
//       type : 'inline',
//       opts : {
//         touch: false,
//         clickSlide: false,
//         clickContent: false,
//         afterShow : function( instance, current ) {
//           console.info( 'done!' );
//         },
//         'beforeClose': function(){
//           if(jQuery('#mc-popup-hide').is(':checked')) {
//             setCookie('popup-hide', true, 7);
//           }else {

//           }
//         }
//       }
//     });
//   }
// });


// Background Video Js Start
jQuery(document).on('click', '.cover', function () {

    var player = new Vimeo.Player(document.getElementById('background0-video'));
  
    jQuery(this).children().css({
      'z-index' : 1,
      'opacity': 1
    });
  player.play();
});
// Background Video Js End

// Background Video Js Start
jQuery(document).on('click', '.cover1', function () {

    var player1 = new Vimeo.Player(document.getElementById('background1-video'));
  
    jQuery(this).children().css({
      'z-index' : 1,
      'opacity': 1
    });
  player1.play();
});
// Background Video Js End

// Lang Dropdown Js Start
var dropdown = document.querySelector('.dropdown');
var dropdownBtn = document.querySelector('.dropbtn');
var dropdownItems = document.querySelectorAll('.dropdown-content li a');

dropdown.addEventListener('mouseenter', function() {
  this.classList.add('clicked');
});

dropdown.addEventListener('mouseleave', function() {
  this.classList.remove('clicked');
});

dropdown.addEventListener('click', function() {
  this.classList.toggle('clicked');
});

dropdownItems.forEach(function(item) {
  item.addEventListener('click', function(event) {
    event.preventDefault();
    dropdownBtn.textContent = this.textContent;
       window.location.href= this.href;
  });
});
// Lang Dropdown Js End

// Blog Page Search Js Start
if(jQuery('body').hasClass('template-blog')) {
var url = window.location.href;     // Returns full URL (https://example.com/path/example.html)
// var url = "http://relaunch.headonline.de/projekte/#filter=kataloge-database";
var arguments = url.split('?')[1].split('type');
arguments.shift();
console.log(arguments);
if (arguments.length === 1) {
  jQuery(".hide-content").css("display", "none");
}
  }
// Blog Page Search Js End

// Home Section Start
jQuery(document).ready(function() {
  if(jQuery('.our-more-product .row').length > 0) {
    jQuery('.our-more-product .row').slick({ 
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
    });
  }
  });


jQuery(document).ready(function() {
jQuery(window).resize(function(){  /*Bind an event handler to the "resize"*/
  if (jQuery(window).width() < 767) {
        if(jQuery('.home-video-mobile-carousel .row').length > 0) {
    jQuery('.home-video-mobile-carousel .row').slick({ 
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
    });
  }
    }
});
  });

// Home Section End

